import { Box, Flex, Heading, Container, HStack } from '@chakra-ui/react'
import { FC, useEffect } from 'react'

import useProfile from '@hook/shared/use-profile'

import Layout from '@component/Layout'
import ProfilesSearcher from '@component/Modules/Profile/Searcher'
import ProfilesTable from '@component/Modules/Profile/Table'

const Users: FC = () => {
  const { getProfiles, profiles } = useProfile()

  useEffect(() => {
    profiles?.length === 0 && getProfiles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Perfis" withBackdroundDrop>
      <Container maxW="container.lg" py={6}>
        <Box bg="white" p={6} borderRadius={8} boxShadow="sm">
          <Flex alignItems="center" justifyContent="space-between" mb={4}>
            <Heading size="lg">Perfis</Heading>

            <ProfilesSearcher />

            <HStack spacing={2}></HStack>
          </Flex>
          <ProfilesTable />
        </Box>
      </Container>
    </Layout>
  )
}

export default Users
